<template>
  <el-card shadow="never" class="lad-reviews--comment">
    <div class="comment-header">
      <LadAvatar
        :size="30"
        :src="_user.profile.avatar.src"
        :src-set="_user.profile.avatar.srcset"
      />

      <div class="comment-header--right">
        <strong>{{ fullname }}</strong>
        <span>
          {{ $dayjs(created_at, 'YYYY-MM-DD HH:mm:ss') | ladFnStrDate }}
        </span>
      </div>
    </div>

    <LadSummary :text="message" :max-length="200" inline-toogle />
  </el-card>
</template>

<script>
import LadAvatar from '@/components/avatar'
import LadSummary from '@/components/summary'

export default {
  name: 'LadReviewComment',
  components: {
    LadAvatar,
    LadSummary,
  },
  props: {
    message: { type: String, required: true },
    // eslint-disable-next-line vue/prop-name-casing
    created_at: { type: String, required: true },
    // eslint-disable-next-line vue/prop-name-casing
    _user: { type: Object, required: true },
  },
  computed: {
    fullname() {
      const firstname = this._user.profile.firstname
        ? this._user.profile.firstname
        : ''
      const lastname = this._user.profile.lastname
        ? this._user.profile.lastname
        : ''

      return `${firstname} ${lastname}`.trim()
    },
  },
}
</script>

<style lang="scss">
.lad-reviews {
  &--comment {
    .el-card__body {
      padding: 12px;
      display: grid;
      grid-template-columns: 1fr;

      .comment-header {
        display: grid;
        grid-column-gap: 10px;
        align-items: center;
        grid-template-columns: auto 1fr auto;

        &--right {
          display: grid;
          grid-gap: 10px;
          grid-template-columns: 1fr auto;

          & > span {
            font-style: italic;
            text-align: right;
            font-size: 12px;
          }
        }
      }

      .lad-summary {
        margin-left: 40px;
      }
    }
  }

  &--sm {
    .lad-reviews--comment {
      .el-card__body {
        grid-gap: 10px;

        .comment-header {
          grid-template-columns: 1fr auto;

          .lad-avatar {
            order: 1;
          }

          &--right {
            grid-template-columns: 1fr;

            & > span {
              text-align: left;
            }
          }
        }

        .lad-summary {
          margin-left: 0;
        }
      }
    }
  }
}
</style>
